// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b4e9e932","239":"ee0f3291","732":"327c50a6"}[chunkId] + ".chunk.js";
};